export default "__VITE_ASSET__DgnlqeRm__"